import { AxiosError } from 'axios';
import { useState } from 'react';
// import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import { ITrackPackageResponse } from '../../models/trackPage/trackPackage.model';
import { trackPackageActions } from '../../redux/slices/trackPackageSlice';
import { useAppDisPatch } from '../../redux/store';
import { TRACK } from '../../routes/routeConstants';
import useHttps from '../useHttps';

const useTrackPackages = () => {
  const dispatch = useAppDisPatch();
  const request = useHttps();
  const navigate = useNavigate();
  const [trackingInfo, setTrackingInfo] = useState<ITrackPackageResponse>();
  const [trackPackageLoading, setTrackPackageLoading] = useState(false);

  const onTrackPackagesError = (err: AxiosError<ErrorHttpResponse>) => {
    console.log(err);
    setTrackingInfo(undefined);
    dispatch(trackPackageActions.setTrackPackage({ trackPackage: undefined }));
  };

  const onTrackPackagesSuccess = (
    packageId: string,
    message: string,
    data: ITrackPackageResponse
  ) => {
    navigate(`/${TRACK}/${packageId}`);
    setTrackingInfo(data);
    dispatch(trackPackageActions.setTrackPackage({ trackPackage: data }));
  };

  const wrapOnTrackPackagesSuccess =
    (packageId: string) =>
      ({ message, data }: SuccessHttpResponse<ITrackPackageResponse>) => {
        return onTrackPackagesSuccess(packageId, message, data);
      };

  const trackPackages = (packageId: string) => {
    const url: HttpConfig = {
      // url: `general-service/packages/${packageId}`,
      url: `general-service/external/packages/track/${packageId}`,
      method: 'get',
    };

    dispatch(trackPackageActions.setTrackPackage({ trackPackage: undefined }));

    request(
      url,
      wrapOnTrackPackagesSuccess(packageId),
      setTrackPackageLoading,
      onTrackPackagesError
    );
  };

  return { trackPackages, trackPackageLoading, trackingInfo };
};

export default useTrackPackages;
